import Vue from "vue";
import Router from "vue-router";
import Monitor from "./views/Monitor.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "supervise",
      component: Monitor
    },
    {
      path: "/appversion",
      name: "appversion",
      component: () => import("./views/AppVersion.vue")
    },
    {
      path: "/pluginManage",
      name: "pluginManage",
      component: () => import("./views/pluginManage.vue")
    },
    {
      path: "/objStorage",
      name: "objStorage",
      component: () => import("./views/objStorage.vue")
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/login.vue")
    }
  ]
});
